import React, { useEffect, useMemo, useState } from "react";
import TextStyles from "../../../../../../components/Elements/TextStyles/TextStyles";
import { useNavigate } from "react-router-dom";
import { ReactComponent as BackIcon } from "../../../../../../assets/svgs/back-button.svg";
import CardsBorder from "../../../../../../components/Cards/CardsBorder";
import CustomerLevel from "./CustomerLevel";
import ProjectLevel from "./ProjectLevel";
import { useSelector } from "react-redux";
import { getApi } from "../../../../../../api/api_instance";
import { API_URLS } from "../../../../../../api/apiUrls";
import { Spin } from "antd";

const LicenceDetailPage = ({ customerLicense = false }) => {
  const navigate = useNavigate();
  const { user } = useSelector((state) => state.auth);
  const [selected, setSelected] = useState("customer");
  const [loading, setLoading] = useState(true);
  const [customerData, setCustomerData] = useState(null);
  const [projectLicenses, setProjectLicenses] = useState([]);

  useEffect(() => {
    const fetchLicenses = async () => {
      try {
        setLoading(true);
        const [customerRes, projectRes] = await Promise.all([
          user?._id
            ? getApi({ apiUrl: API_URLS.LICENSEACCESS(user._id) })
            : Promise.resolve(null),
          getApi({ apiUrl: API_URLS.GET_PROJECT_LICENSES }),
        ]);

        if (customerRes?.success) {
          setCustomerData(customerRes.data || user || null);
        } else {
          setCustomerData(user || null);
        }

        if (projectRes?.success) {
          setProjectLicenses(projectRes.data || []);
        } else {
          setProjectLicenses([]);
        }
      } catch (error) {
        console.error("Error fetching license details:", error);
        setCustomerData(user || null);
        setProjectLicenses([]);
      } finally {
        setLoading(false);
      }
    };

    fetchLicenses();
  }, [user]);

  const summary = useMemo(() => {
    console.log("sub_admin total:", customerData?.license?.sub_admin?.total);
    const totalProjects = projectLicenses.length;
    const activeUsers = customerData?.activeUserCount ?? 0;
    const customerLicense =
      (customerData?.license?.sub_admin?.total ?? 0) +
      (customerData?.license?.management_view?.total ?? 0);
    const projectLicense = projectLicenses.reduce((projectTotal, project) => {
      return (
        projectTotal +
        Object.values(project?.license || {}).reduce((licenseTotal, item) => {
          return licenseTotal + Number(item?.total?.total ?? item?.total ?? 0);
        }, 0)
      );
    }, 0);

    return {
      totalProjects,
      activeUsers,
      customerLicense,
      projectLicense,
    };
  }, [customerData, projectLicenses]);

  if (loading) {
    return (
      <div className="flex justify-center items-center h-screen">
        <Spin />
      </div>
    );
  }

  return (
    <div style={{ padding: "20px" }}>
      <div>
        {!customerLicense && (
          <div>
            <div
              className="flex justify-end text-xs"
              style={{ fontFamily: "Calibri" }}
            >
              <p>Home </p>
              <span> / </span>
              <p>License </p> <span> / </span>
              <TextStyles className="text-[#06513D]">
                {" "}
                License Detail Page
              </TextStyles>
            </div>
            <div className="flex justify-start ">
              <div>
                <BackIcon
                  onClick={() => {
                    navigate("/");
                  }}
                />
              </div>
              <div className="items-center mt-3">
                <TextStyles
                  className="text-[#06513D]"
                  style={{ fontSize: "20px" }}
                >
                  License Detail Page
                </TextStyles>
              </div>
            </div>
          </div>
        )}

        <div className="py-5">
          <CardsBorder>
            <div className="px-16">
              {!customerLicense && (
                <div className="flex justify-between ">
                  <TextStyles
                    style={{
                      fontSize: "20px",
                      fontWeight: 500,
                      marginLeft: "20px",
                    }}
                    className="text-[#06513D]  whitespace-normal break-words"
                  >
                    CUSTOMER NAME:{" "}
                    {customerData?.organization?.name || user?.name || "N/A"}
                  </TextStyles>
                </div>
              )}
              {!customerLicense && (
                <p
                  style={{
                    marginLeft: "20px",
                    fontSize: "16px",
                    fontWeight: "300",
                  }}
                >
                  Customer ID: {customerData?.userId || user?.userId || "N/A"}
                </p>
              )}
              <div className="pb-3 px-4">
                <hr />
              </div>
              <div className="flex-col text-center pb-10">
                <div className="flex justify-between mx-8">
                  <p>Total Projects</p>
                  <p>Active Users</p>
                  <p>Customer License</p>
                  <p>Project License</p>
                </div>
                <div className="pb-3 px-4">
                  <hr />
                </div>
                <div className="flex justify-between mx-8">
                  <p className="text-center">{summary.totalProjects}</p>
                  <p className="text-center">{summary.activeUsers}</p>
                  <p className="text-center">{summary.customerLicense}</p>
                  <p className="text-center">{summary.projectLicense}</p>
                </div>
              </div>
            </div>
          </CardsBorder>
        </div>

        <div className="pb-5">
          <CardsBorder>
            <div className="mx-10">
              <TextStyles
                className="text-[#06513D]"
                style={{
                  fontSize: "20px",
                  fontWeight: 500,
                }}
              >
                LICENSES & FEATURES MANAGEMENT
              </TextStyles>
              <p className="font-light mt-[-10px]">
                Manage license quantities and feature access for this customer
              </p>
            </div>
          </CardsBorder>
        </div>

        <div className="pb-5">
          <div className="py-5">
            <div className="flex w-full mt-4 overflow-hidden rounded-t-2xl border-b border-[#06513D] ">
              <div
                className={`flex-1 text-center py-3 text-lg font-semibold cursor-pointer transition-all duration-200 ${
                  selected === "customer"
                    ? "bg-[#06513D] text-white"
                    : "bg-white text-[#06513D] hover:bg-[#F8F8F8]"
                }`}
                onClick={() => setSelected("customer")}
              >
                CUSTOMER-LEVEL
              </div>
              <div
                className={`flex-1 text-center py-3 text-lg font-semibold cursor-pointer transition-all duration-200 ${
                  selected === "project"
                    ? "bg-[#06513D] text-white "
                    : "bg-white text-[#06513D] hover:bg-[#F8F8F8]"
                }`}
                onClick={() => setSelected("project")}
              >
                PROJECT-LEVEL
              </div>
            </div>
          </div>
        </div>

        <div>
          {selected === "customer" ? (
            <CustomerLevel
              customerData={customerData}
              customerSummary={summary}
              customerName={customerData?.name || user?.name}
            />
          ) : (
            <ProjectLevel projects={projectLicenses} />
          )}
        </div>
      </div>
    </div>
  );
};

export default LicenceDetailPage;
